/* eslint-disable react-hooks/exhaustive-deps */
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import {
  IApiResponse,
  IErrorResponse,
  IPaginateApiResponse,
  IPaginationRequest,
} from "model";
import { useEffect, useState } from "react";
import configureStore from "redux/configurations/configureStore";
import { useAppSelector } from "redux/configurations/reduxHooks";

type IOptions = {
  refresh?: boolean;
  holdRequest?: boolean;
};

export const usePaginationRequest = <
  R extends IPaginationRequest,
  T extends any
>(
  request: R,
  api: (params: R) => Promise<IErrorResponse | IPaginateApiResponse<T>>,
  deps?: any[],
  options?: IOptions,
  callback?: (cb: { holdRequest: boolean }) => void
) => {
  const { loading, result } = useBaseApiRequestHook<R, T>(
    request,
    api,
    deps,
    options,
    callback
  );
  return {
    loading,
    result,
  };
};
export const useRequest = <R extends any, T extends any>(
  request: R,
  api: (params: R) => Promise<IErrorResponse | IApiResponse<T>>,
  deps?: any[],
  options?: IOptions,
  callback?: (cb: { holdRequest: boolean }) => void
) => {
  const { loading, result } = useBaseApiRequestHook<R, T>(
    request,
    api,
    deps,
    options,
    callback
  );
  return {
    loading,
    data: result.data,
  };
};

export const useBaseApiRequestHook = <R extends any, T extends any>(
  request: R,
  api: (
    params: R
  ) => Promise<IErrorResponse | IApiResponse<T> | IPaginateApiResponse<T>>,
  deps?: any[],
  options?: IOptions,
  callback?: (cb: { holdRequest: boolean }) => void
) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [result, setResult] = useState<
    IApiResponse<T> | IPaginateApiResponse<T>
  >({} as IApiResponse<T> | IPaginateApiResponse<T>);
  const warehouse = useAppSelector(
    (state) => state.IdentityReducer.currentWarehouse
  );

  const _requestApi = async () => {
    const params = {
      ...(request as any),
      warehouseId:
        (request as any).warehouseId ||
        configureStore().store.getState().IdentityReducer.currentWarehouse?.id,
    };
    return (await api(params)) as IApiResponse<T> | IPaginateApiResponse<T>;
  };

  const getData = async () => {
    try {
      setLoading(true);
      const result = await _requestApi();
      if (result.succeeded) {
        setResult(result);
      } else {
        const err = result as IErrorResponse;
        AlertHelper.showAlert(err.message[0].Text, EAlertType.ERROR);
      }
    } catch (error) {
      AlertHelper.showAlert("Lỗi hệ thống", EAlertType.ERROR);
    } finally {
      setLoading(false);
      callback && callback({ holdRequest: true });
    }
  };

  useEffect(() => {
    if (!options?.holdRequest) {
      getData();
    }
  }, [request, warehouse, ...(deps || [])]);

  // useEffect(() => {
  //   if (!options?.holdRequest) {
  //     getData();
  //   }
  // }, deps);

  useEffect(() => {
    if (options?.refresh) {
      getData();
    }
  }, [options?.refresh]);
  return {
    loading,
    result,
  };
};
